import { inject, Injectable } from '@angular/core';
import { IxNgValidationService, IxValidationException, IxValidationMessageType } from 'ix-ng-forms';
import { IxNgComValidationService } from 'ix-ng-components';

@Injectable({
  providedIn: 'root',
})
export class ValidationDialogService {
  public validationRecordOnCloseCustomAction?: () => void;
  public showPrezriOpozorilaButton = true;
  private ixNgValidationService = inject(IxNgValidationService);
  private ixNgComValidationService = inject(IxNgComValidationService);

  constructor() {
    /* empty */
  }

  /** Funkcija se uporabi za prikaz custom validacijskega okna. */
  public handleSubscriptionErrorCallback(
    error: IxValidationException,
    ignoreWarningsAction?: () => void,
    onCloseAction?: () => void,
  ): boolean {
    if (error instanceof IxValidationException && this.ixNgValidationService) {
      // TODO: preveri ali je delovanje pravilno
      this.ixNgValidationService.validationRecordList.push(...error.messages);
      const hasError = error.messages.find(
        (x) => x.type === IxValidationMessageType.ERROR || x.type.toString() === 'ERROR',
      );
      if (hasError === undefined) {
        this.ixNgValidationService.updateNotification(
          error.messages,
          ignoreWarningsAction,
          undefined,
          this.ixNgValidationService.validationRecordOnCloseAction,
        );
      } else {
        this.ixNgValidationService.updateNotification(
          error.messages,
          undefined,
          undefined,
          this.ixNgValidationService.validationRecordOnCloseAction,
        );
      }
      this.ixNgComValidationService.appComValidationOpen = true;
      if (onCloseAction) {
        this.validationRecordOnCloseCustomAction = onCloseAction;
      }
      return true;
    }
    return false;
  }
}
